<!-- Translated: yes -->
<template>
  <div :class="'datepicker datepicker-' + type">
    <div class="pager">
      <span>
        <button :class="'prev' + (canGoToPrevious ? '' : ' disabled')" @click="prevMonth">
          <icon name="chevron-left" :scale="0.7"></icon>
        </button>
      </span>
      <span class="month">
        <!-- <span class="month-dropdown">{{ month }} <span class="thin">{{ year }}</span></span> -->
        <Dropdown
          :options="validMonths"
          :validated="false"
          :value="''"
          label=""
          :with-background="false"
          @changed="updateMonthFromPicker"
          :bold-label="false"
          :allow-empty="false"
          :combo="false"
          type="month"
          ref="monthDropdown"
          >
        </Dropdown>
      </span>
      <span>
        <button :class="'next' + (canGoToNext ? '' : ' disabled')" @click="nextMonth">
          <icon name="chevron-right" :scale="0.7"></icon>
        </button>
      </span>
    </div>
    <div class="dates">
      <div class="table">
        <div class="thead">
          <div class="tr">
            <div class="th" v-for="day in days">
              {{ day.label }}
            </div>
          </div>
        </div>
        <div class="tbody">
          <div class="tr" v-for="week in weeks">
            <div class="td" v-for="(day, index) in week.days">
              <span class="week-number" v-if="!index">
                v.{{ week.days[0].value | date('W') }}
              </span>
              <button
                :class="[
                  'day',
                  day.active && 'active',
                  day.activeRange && 'active-range',
                  day.activeEnd && 'active-end',
                  day.current && 'current',
                  day.unavailable && 'unavailable',
                  day.special && 'special',
                ]"
                v-if="day.visible"
                @click="setValue(day)"
                :disabled="!day.enabled"
              >

              <popper trigger="hover" :options="{placement: 'right'}" v-show="showPopper(day)">
                <div class="popper">
                  <div>Fullbokat</div>
                </div>
                <span slot="reference">
                  {{ day.label }}
                </span>
              </popper>

              <span v-show="!showPopper(day)">
                {{ day.label }}
              </span>

              </button>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mmoment from 'moment';
import { extendMoment } from 'moment-range';

import Popper from 'vue-popperjs';
import Dropdown from '@/components/components/Dropdown';
import 'vue-popperjs/dist/css/vue-popper.css';

// import {
// //   map,
// //   flow,
//   chunk,
// } from 'lodash/fp';

const moment = extendMoment(mmoment);

export default {
  components: {
    popper: Popper,
    Dropdown,
  },
  props: {
    value: {},
    valueEnd: {},
    type: {},
    range: {
      default: false,
    },
    selectRange: {
      default: false,
    },
    validDate: {
      type: Function,
      default: () => true,
    },
    validRangeDate: {
      type: Function,
      default: () => true,
    },
    startMonth: {
      default: '',
    },
    allowPrevious: {
      default: false,
    },
    disabledDays: {
      default: false,
    },
    specialDays: {
      default: false,
    },
    showAllMonths: {
      default: false,
    },
  },
  data() {
    return {
      currentMonth: null,
      validMonths: [],
    };
  },
  beforeMount() {
    if (!this.currentMonth) {
      this.currentMonth = moment(this.value || undefined).startOf('month').toDate();
    }
  },
  mounted() {
    this.$refs.monthDropdown.setValue({ value: moment(this.currentMonth).format('YYYY-MM-DD') }, true);

    console.log('Datepicker', this.specialDays);

    this.$nextTick(() => {
      if (this.value) {
        this.currentMonth = moment(this.value).startOf('month').toDate();
        this.$refs.monthDropdown.setValue({ value: moment(this.currentMonth).format('YYYY-MM-DD') }, true);
      } else if (this.startMonth) {
        this.currentMonth = moment(this.startMonth).startOf('month').toDate();
        console.log(this.startMonth);
        console.log(this.currentMonth);
        this.$refs.monthDropdown.setValue({ value: moment(this.startMonth).format('YYYY-MM-DD') }, true);
      } else {
        let date = false;
        let i = 0;
        while (i < 365) {
          date = moment().add(i, 'days');
          if (this.validRangeDate(date)) {
            break;
          }
          date = undefined;
          i += 1;
        }
        this.currentMonth = moment(date).startOf('month').toDate();
        this.$refs.monthDropdown.setValue({ value: moment(this.currentMonth).format('YYYY-MM-DD') }, true);
      }

      let i = 0;
      this.validMonths = [];
      let lastMonth = 0;
      while (i < 365) {
        let date = moment().add(i, 'days');
        if (this.validRangeDate(date)) {
          const key = moment(date).startOf('month').format('YYYY-MM-DD');
          if (lastMonth !== key) {
            this.validMonths.push({
              value: key,
              title: moment(date).startOf('month').format('MMMM YYYY'),
            });
          }
          lastMonth = key;
        }
        date = undefined;
        i += 1;
      }

      if (this.showAllMonths) {
        this.validMonths = [];

        i = -12;

        while (i < 12) {
          const date = moment().add(i, 'months');
          const key = moment(date).startOf('month').format('YYYY-MM-DD');

          this.validMonths.push({
            value: key,
            title: moment(date).startOf('month').format('MMMM YYYY'),
          });

          i += 1;
        }
      }

      this.$emit('month-change', { month: this.currentMonth });
    });
  },
  computed: {
    month() {
      return moment(this.currentMonth).format('MMMM');
    },
    monthForDropdown() {
      return moment(this.currentMonth).format('YYYY-MM-DD');
    },
    year() {
      return moment(this.currentMonth).format('YYYY');
    },
    days() {
      return [
        { label: this.$i18n.t('general.weekdays.short.m') },
        { label: this.$i18n.t('general.weekdays.short.tu') },
        { label: this.$i18n.t('general.weekdays.short.w') },
        { label: this.$i18n.t('general.weekdays.short.th') },
        { label: this.$i18n.t('general.weekdays.short.f') },
        { label: this.$i18n.t('general.weekdays.short.sa') },
        { label: this.$i18n.t('general.weekdays.short.su') },
      ];
    },
    weeks() {
      const month = moment.range(
        moment(this.currentMonth),
        moment(this.currentMonth).endOf('month'),
      );

      const visibleRange = moment.range(
        moment(this.currentMonth).startOf('isoWeek'),
        moment(this.currentMonth).endOf('month').endOf('isoWeek'),
      );

      const visibleDays = [];

      let date = visibleRange.start.add(-1, 'days');
      let i = 0;
      const max = visibleRange.end.diff(date, 'days');

      while (i < max) {
        date = moment(date).add(1, 'days').toDate();
        visibleDays.push(moment(date));
        i += 1;
      }

      // Array.from(visibleRange.by('day'));

      const mapped = visibleDays.map(day => ({
        label: day.format('D'),
        visible: day.within(month),
        value: day.toDate(),
        enabled: ((
          (this.selectRange && this.value)
          ? this.validRangeDate(day)
          : this.validDate(day)
        ) && ((day.isSame(moment(), 'day') || day.isAfter(moment())) || this.allowPrevious)),
        active: day.isSame(this.value, 'day'),
        activeRange: day.isBetween(this.value, this.valueEnd),
        activeEnd: day.isSame(this.valueEnd, 'day'),
        current: day.isSame(moment(), 'day'),
        unavailable: this.inArray(day.format('YYYY-MM-DD'), this.disabledDays),
        special: this.inArray(day.format('YYYY-MM-DD'), this.specialDays),
      }));

      const chunked = [[]];
      let chunk = 0;
      mapped.forEach((day, index) => {
        if (index && (index % 7 === 0)) {
          chunk += 1;
          chunked[chunk] = [];
        }
        chunked[chunk].push(day);
      });

      const newMapped = chunked.map(days => ({
        days,
      }));

      //   chunk(7),
      //   map(days => ({
      //     days,
      //   })),
      // ])(visibleDays);

      return newMapped;
    },
    canGoToPrevious() {
      return this.getRelatedMonth(this.currentMonth, -1);
    },
    canGoToNext() {
      return this.getRelatedMonth(this.currentMonth, 1);
    },
  },
  methods: {
    inArray(needle, haystack) {
      let i = 0;
      const length = haystack.length;
      for (i = 0; i < length; i += 1) {
        if (haystack[i] === needle) return true;
      }
      return false;
    },
    setValue(day) {
      let localValue = day.value;

      if (day.active) {
        localValue = null;
      }

      // Updating the end
      if (this.selectRange && this.value) {
        if (this.valueEnd) {
          this.$emit('change', localValue);
          this.$emit('change-end', null);
        } else if (localValue <= this.value) {
          this.$emit('change', localValue);
          this.$emit('change-end', null);
        } else {
          this.$emit('change-end', localValue);
        }
      } else {
        /**
         * Wait for the outerclick event to trigger before the change event is sent.
         */
        this.$emit('change', localValue);
        this.valueEnd = null;
        this.$emit('change-end', null);
      }
    },
    prevMonth() {
      const previousMonth = this.getRelatedMonth(this.currentMonth, -1);

      if (previousMonth) {
        this.currentMonth = moment(previousMonth).toDate();
        this.$refs.monthDropdown.setValue({ value: moment(previousMonth).format('YYYY-MM-DD') }, true);
        this.$emit('month-change', { month: this.currentMonth });
      }
    },
    nextMonth() {
      const nextMonth = this.getRelatedMonth(this.currentMonth, 1);

      if (nextMonth) {
        this.currentMonth = moment(nextMonth).toDate();
        this.$refs.monthDropdown.setValue({ value: moment(nextMonth).format('YYYY-MM-DD') }, true);
        this.$emit('month-change', { month: this.currentMonth });
      }
    },
    getRelatedMonth(date, add) {
      const currentDate = moment(date).format('YYYY-MM-DD');
      const validMonths = this.validMonths;

      /* eslint-disable */
      for (const i in validMonths) {
        if (validMonths.hasOwnProperty(i)) {
          const validDate = moment(validMonths[i].value).format('YYYY-MM-DD');

          if (validDate === currentDate) {
            if (validMonths[parseInt(i, 10) + add]) {
              return validMonths[parseInt(i, 10) + add].value;
            }
          }
        }
      }
      /* eslint-enable */

      return null;
    },
    updateMonth() {
      this.$nextTick(() => {
        let date = moment(this.value || undefined).toDate();
        let found = false;
        const max = 300;
        let i = 0;
        while (!found) {
          date = moment(date).add(1, 'days').toDate();
          if (this.validRangeDate(date)) {
            found = true;
          }
          if (i >= max) {
            found = true;
          }
          i += 1;
        }
        if (i < 300) {
          const diff = moment(date).startOf('month').diff(moment(this.value).startOf('month'), 'months');
          i = 0;
          while (i < diff) {
            this.nextMonth();
            i += 1;
          }
        }
      });
    },
    showPopper(day) {
      if (!day.unavailable) {
        return false;
      }

      if (day.active) {
        return false;
      }

      if (day.activeRange) {
        return false;
      }

      if (day.activeEnd) {
        return false;
      }

      if (day.current) {
        return false;
      }

      return true;
    },
    updateMonthFromPicker(e) {
      this.currentMonth = moment(e.value).toDate();
      this.$emit('month-change', { month: this.currentMonth });
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.datepicker
  display block
  max-width 400px
  +max-mobile()
    max-width: 100%
    width: 100%

.pager
  background-color #f9f9f9
  display flex
  justify-content center
  align-items center
  +max-mobile()
    width: 100%
  .month
    united-heavy()
    font-size 22px
    text-transform uppercase
    padding 10px space-2
    position relative
    top .125em
    display inline-block
    min-width 175px
    text-align center
    // .thin
    //   font-weight: 100
    //   font-size 75%
  button
    button-reset()
    outline none
    border-radius 9999px
    width 20px
    height 20px
    display flex
    align-items center
    justify-content center
    background-color deep-sea-blue
    color white
    margin space-1
    &:hover
      background-color deep-sea-blue
      opacity 0.8
      @media (hover: none) {
        background-color deep-sea-blue
        opacity 1
      }

div.dates
  padding 0 20px 0 50px
  +max-mobile()
    padding 0 12px 0 35px
  .table
    width 100%
    //max-width 320px
    margin 0 auto
    display table
    table-layout fixed
    .thead
      display table-row-group
    .tbody
      display table-row-group
    .tr
      width 100%
      display table-row
      table-layout fixed
    .th
      text-align center
      width (100% / 7)
      font-size 10px
      text-transform uppercase
      font-weight bold
      padding-top space-1
      display: table-cell
    .td
      text-align center
      padding-top 10px
      padding-bottom 10px
      position: relative;
      display: table-cell
      .week-number
        //font-size 10px
        color #666
        display: inline-block;
        position: absolute;
        left -34px
        top 18px
        font-weight: 300
        text-align: center
        +max-mobile()
          left -28px


button.day
  button-reset()
  outline none
  border-radius 9999px
  width space-3
  height space-3
  display inline-flex
  display inline-block
  align-items center
  justify-content center
  text-align center
  font-size 13px
  font-weight bold
  &:disabled
    color lighten(silver, 70%)
    opacity 1
    &:hover
      background-color white
      border-width 0
  &:not(:disabled)
    background-color light-blue-grey
    color deep-sea-blue
    &:hover
      background-color dark-blue
      color white
  &.active,
  &.active-end,
  &.active-range
    background-color gold !important
    color white !important
    opacity: 1 !important
    &:hover
      background-color gold
  &.current
    border 1px solid #005580
    &:disabled
      border-color lighten(silver, 70%)

  &.special
    color white
    background-color #005580
    &:disabled
      color lighten(silver, 70%)
      background none
      opacity 1
  &.unavailable:disabled
    color white
    background-color: lighten(#be241c, 70%)
    &:hover
      background-color: lighten(#be241c, 70%)
      color white
      border-width 0

.datepicker-skiletting
  button.day
    &.active-range
      &:disabled
        background none
        color lighten(silver, 70%)
        opacity 1
        &:hover
          background-color white
          border-width 0

.popper
  border-radius 2px
  background-color #262626
  font-family Interstate
  font-size 12px
  font-weight 300
  color #ffffff
  padding 12px
  box-shadow none
  border 0
  text-align left

.month-dropdown
  background: #fff;
  color: #262626;
  border: 1px solid #bfd9e1;
  padding: 0.2em 0.5em;
  option
    text-transform uppercase

.next.disabled,
.prev.disabled
  disabled()

</style>



// WEBPACK FOOTER //
// Datepicker.vue?a5c84514